import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getBulkActionLogs = (params = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/bulk-action-logs`, {
    headers: authHeaders(),
    params,
  });

export const exportBulkActionLogs = (formatType) =>
  axiosInstance.get(`${ADMIN_API_URL}/bulk-action-logs/export`, {
    headers: authHeaders(),
    params: { format: formatType },
    responseType: "blob",
  });
